import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { ShareObjectsController } from '@commoncore/controller/ShareObjectsController';
import { CleverTapEventsService } from '@commoncore/services/clevertap-events-service';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  standalone:true,
  selector: 'app-enhanced-share-link',
  templateUrl: './enhanced-share-link.component.html',
  styleUrls: ['./enhanced-share-link.component.scss'],
  imports:[DependenciesModule]
})
export class EnhancedShareLinkComponent implements OnInit {
  showEnhancedShareLink:any;
  universalService: any;
  currentDate : any;
  controller: any;
  listService:any;
  implRef: any;
  defaultExpiryDate:any = "";
  minDateSelection:any = "";
  selExpiryDate:any = "";
  defaultCurrentDateForTitle: any = "";
  localStorageService : any;
  showFamilyShare:boolean = false;
  isAccessControlAllowed:boolean = false;
  isPasswordFieldEnabled:boolean = false;
  isEditModeOn:boolean = false;
  showPasswordData:boolean = false;
  isValidNameInput:boolean = false;
  isValidPasswordInput:boolean = false;
  isCopyLink:boolean = false;
  copyText : string = "Copy Link";
  pageModalHeader = "Create Link";
  shareAccessService: any;
  cleverTapEventsService: CleverTapEventsService;
  dateControl = new FormControl();
  router:any;
  recalculateHeightService:any;

  constructor(private globalService:GlobalService, private cdRef :ChangeDetectorRef) {
    this.setEnvObjects(this.globalService);
  }

  ngOnInit(): void {
    var classRef = this;
    
    this.subscriptionToShareEvent();
  }

  setEnvObjects(globalService){
    this.listService = globalService.getListServiceRef();
    this.controller= ShareObjectsController.getInstance(globalService);
    this.controller.setEnvObjects(this.globalService);
    this.universalService = globalService.getUniversalServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.shareAccessService = globalService.getShareAccessServiceRef();
    this.implRef = this.controller.shareObjectsImplementation;
    this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
    this.router = this.globalService.getRouterRef();
    this.recalculateHeightService = globalService.getContainerHeightCalculatorService();
  }

  subscriptionToShareEvent(){
    let classRef = this;
    AppEvents.optionSelected.subscribe(event => {
      if(event["showEnhancedShareLink"]){
        classRef.showEnhancedShareLink = event["showEnhancedShareLink"];
        classRef.universalService.showEnhancedShareLink = event["showEnhancedShareLink"];
        classRef.initializeComponent();
        classRef.cdRef.detectChanges();
      } else if(event["closeAll"]){
        classRef.showEnhancedShareLink = false;
        classRef.universalService.showEnhancedShareLink = false;
        //classRef.listService.deSelectAll("");
        this.cdRef.detectChanges();        
      }
    })
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if(this.showEnhancedShareLink) {
      if (event.key === "Escape" && !$('#share-modal').is(':visible')) {
          this.confirmDiscard();
      }
    }
  }

  confirmDiscard() {
    if(!this.universalService.isAnyChange) {
      if(!this.universalService.inAppWebViewOpened){
        this.listService.deSelectAll();
      }
      this.closeNav();
    } else {
      setTimeout(()=>{
        let ele = document.querySelector('.add-people-panel') as any
        if(ele){
          ele.style.zIndex = '999';
        }
        this.universalService.showModalBackdrop();
        this.universalService.popUpToBeOpened = 'shareDiscardPopUp';
      },100)
    }
  }

  getCurrentDateTimeFormat() {
    this.currentDate = new Date();
    let date = this.currentDate.getDate();
    let mon = this.universalService.LONG_MONTH_NAMES[this.currentDate.getMonth()].slice(0,3);
    let year = this.currentDate.getFullYear();
    
    this.minDateSelection = (this.currentDate.getFullYear() + "-" + ("0" + (this.currentDate.getMonth()+1)).slice(-2) + "-" + ("0" + this.currentDate.getDate()).slice(-2));
    /*this.defaultCurrentDateForTitle = ("0" + this.currentDate.getDate()).slice(-2) +
    ("0" + (this.currentDate.getMonth()+1)).slice(-2) + 
    (this.currentDate.getFullYear().toString().substr(-2)) + 
    ("0" + this.currentDate.getHours()).slice(-2) + 
    ("0" + this.currentDate.getMinutes()).slice(-2) + 
    ("0" + this.currentDate.getSeconds()).slice(-2);*/
    this.defaultCurrentDateForTitle = date+mon+year+"_"+
        ("0" + this.currentDate.getHours()).slice(-2) + 
        ("0" + this.currentDate.getMinutes()).slice(-2) + 
        ("0" + this.currentDate.getSeconds()).slice(-2);
    this.isValidNameInput = true; // set to true after setting valid name (default)
    // show 6 months later date
    var postDate = new Date(this.currentDate.setMonth(this.currentDate.getMonth()+6));
    this.defaultExpiryDate = (postDate.getDate() + " " + this.universalService.SHORT_MONTH_NAMES[postDate.getMonth()] + " " + postDate.getFullYear());
    this.selExpiryDate = (postDate.getFullYear() + "-" + ("0" + (postDate.getMonth()+1)).slice(-2) + "-" + ("0" + postDate.getDate()).slice(-2));   
    

    if(this.implRef.shareName == "") {
      this.implRef.shareName = this.defaultCurrentDateForTitle;
    }
  }

  initializeComponent() {
    var self = this;
    
    this.showFamilyShare = ENV_CONSTANTS["constants"]["showFamilyShare"];
    this.implRef.resetUniversalLinkProperties();
    this.isEditModeOn = false;
    this.isPasswordFieldEnabled = false;
    this.isAccessControlAllowed = false;
    this.showPasswordData = false;
    this.isValidNameInput = false;
    this.isValidPasswordInput = false;
    $('#passwordToggle').prop('checked', false);
    $("#linkName").prop('disabled', false);
    this.pageModalHeader = "Create Link";
    this.universalService.isMobileShareOptionClicked = false;
    this.universalService.mobileSelectionModeOn = false;
    this.universalService.showMobOptionMenu = false;
    var userData = this.localStorageService.getUserData(true);
    // if(userData["isFamilyMember"] == "N" || (userData["paidPlan"] && userData["paidPlan"]["planStatus"] == 'E')){
    //   this.isAccessControlAllowed = false;
    //   this.showFamilyShare = false;
    // } else if(userData["isFamilyMember"] == "Y"){
    //   this.isAccessControlAllowed = true;
    // } 

    if(userData["displayPublicShareOptions"] == "Y"){ // displayPublicShareOptions is the new flag introduced for hiding and showing the Set Expiry / Password option (as per product, possible values for this flag are "Y","N" and "D")
      this.isAccessControlAllowed = true;
    }else if(userData["displayPublicShareOptions"] == "N"){
      this.isAccessControlAllowed = false;
    }else{
      this.isAccessControlAllowed = false;
      this.showFamilyShare = false;
    }

    setTimeout(function() {
      self.getCurrentDateTimeFormat();
    });
    //This is required, as keeping in single setTimeout creates an issue - Reason - bug#354356
    setTimeout(() => {
      $('#link-expiry').val(this.selExpiryDate);
      if(this.universalService.isUserOnSharedLinkByMe) {
        this.fetchMangeShareLinkData();
      }
    });

    this.universalService.showModalBackdrop();
    this.openNav();
    jQuery(document).off('focusin.modal');
  }

  fetchMangeShareLinkData() {
    this.pageModalHeader = "Manage Link";
    var selectedShareObject = this.universalService.selectedFile;
    if(this.universalService.selectedFile.FullObject != null) {
      selectedShareObject = this.universalService.selectedFile.FullObject;
    }
    
    this.defaultCurrentDateForTitle = selectedShareObject.shareName;
    

    this.implRef.universalShareUrl = selectedShareObject.shareURL;
    var postDate = new Date(selectedShareObject.expiryDate);
    this.selExpiryDate = (postDate.getFullYear() + "-" + ("0" + (postDate.getMonth()+1)).slice(-2) + "-" + ("0" + postDate.getDate()).slice(-2));
    
    $('#link-expiry').val(this.selExpiryDate);

    if(selectedShareObject.isPassProtected) {
      var passElm = $("#linkPass");
      if (passElm.attr("type") === "text") {
        passElm.attr("type", "password");
      }
      this.showPasswordData = false;
      setTimeout(() => {
        $('#passwordToggle').prop('checked', true);  
      },100);
      this.isPasswordFieldEnabled = true;
      this.fetchPassword(selectedShareObject.shareKey);
    }
  }

  async fetchPassword(shareKey) {
    var result = await this.controller.getUniversalShareLinkPassword(shareKey);
    if(result.password) {
      this.implRef.sharePassword = this.implRef.passwordUtil.decrypytSharePassPhrase(result.password);
      $('#linkPass').val(this.implRef.sharePassword);
    }
  }
  

  openNav() {
    if(!this.universalService.inAppWebViewOpened) {
      jQuery(".create-link-panel-main").animate({"right":"0"}, "200");
      jQuery(".create-link-panel-main").css({"opacity":"1"});
    } else {
      jQuery(".create-link-panel-main").css({"right":"0"});
    }
  }

  closeNav() {
    var classRef = this;    
    jQuery(".create-link-panel-main").animate({"right":"-1000px"}, "200");
    jQuery(".create-link-panel-main").css({"opacity":"0"});
    //(<any>$('#passwordToggle')[0]).checked = false;
    $('#passwordToggle').prop('checked', false);
    classRef.showEnhancedShareLink = false;
    this.universalService.disableModalBackdrop();
    setTimeout(function(){
      classRef.universalService.showEnhancedShareLink = false;
      classRef.recalculateHeightService.sendRecalculateEventToComponents(true);
    }, 500);
    //this.implRef.resetDefaultProperties();
  }

  enablePasswordField(){ 
    this.isPasswordFieldEnabled = (<any>$('#passwordToggle')[0]).checked;
    if(this.isPasswordFieldEnabled == false) {
      if(!this.universalService.isUserOnSharedLinkByMe) {
        this.universalService.isAnyChange = false;
        this.implRef.sharePassword = "";
        this.implRef.isChangePassword = false;
        this.isValidPasswordInput = true; // If field disabled, valid pass is considered
        if(this.implRef.isSetExpiry == true || this.implRef.isShareNameUpdated == true) {
          this.isEditModeOn = true;
        } else {
          this.isEditModeOn = false;
        }
      } else {
        var selectedShareObject = this.universalService.selectedFile;
        if(this.universalService.selectedFile.FullObject != null) {
          selectedShareObject = this.universalService.selectedFile.FullObject;
        }

        if(selectedShareObject.isPassProtected) {
          this.isEditModeOn = true;
          this.implRef.sharePassword = "";
          this.implRef.isChangePassword = true;
          this.universalService.isAnyChange = true;
          this.isValidPasswordInput = true;
        } else {
          if(this.isEditModeOn && this.implRef.isSetExpiry) { // if date was modified
            this.isEditModeOn = true;
            this.isValidPasswordInput = true; // If field disabled, valid pass is considered
          } else {
            this.isEditModeOn = false;
          }
          this.implRef.sharePassword = "";
          this.implRef.isChangePassword = false;
          if(this.universalService.isAnyChange && this.implRef.isSetExpiry) {
            this.universalService.isAnyChange = true;
          } else {
            this.universalService.isAnyChange = false;
          }
        }
      }
    }
    if(this.isPasswordFieldEnabled == true) {
      if(!this.universalService.isUserOnSharedLinkByMe || this.universalService.isUserOnSharedLinkByMe) {
        this.cleverTapEventsService.publicSharePasswordSet();
        this.isEditModeOn = true;
        this.showPasswordData = false;
        this.universalService.isAnyChange = true;
        setTimeout(() => {
          this.validateInput("password", "");
        }, 100);
        this.isValidPasswordInput = false;
      } else {

      }
    }
    // if(this.isPasswordFieldEnabled == true && this.universalService.isUserOnSharedLinkByMe) {
    //   setTimeout(() => {
    //     $('#linkPass').val(this.implRef.sharePassword);  
    //   }, 100);
      
    // }
  }

  setExpiryChange(e) {

    // this.dateControl.valueChanges.pipe(
    //   debounceTime(500),
    //   distinctUntilChanged()
    // ).subscribe((suc) => {
      var expiryDate = $("#link-expiry").val().toString(); //expiryDate = e.target.value;
      if(expiryDate == "") {
        this.isEditModeOn = true;
        this.selExpiryDate = "";
      } else{
        if(expiryDate != null && expiryDate != "") {
          this.cleverTapEventsService.publicShareLinkExpiryChange();
          var todaysDate = new Date();
          todaysDate.setHours(0, 0, 0, 0);
          var newDate = new Date(expiryDate);
  
          /*if(expiryDate.length != 10 || newDate.toString() == "Invalid Date") {
            this.universalService.showToast("Please enter valid date", "error");
            this.isEditModeOn = false;
            return;
          }*/
  
          this.isEditModeOn = true;
          if(newDate < todaysDate) {
            // var msg = "Link expiry date cannot be before " + (todaysDate.getDate() + "/" + (todaysDate.getMonth() + 1) + "/" + todaysDate.getFullYear());
            // this.universalService.showToast(msg, "error");
            // todaysDate = new Date(todaysDate.setMonth(todaysDate.getMonth()+6)); // to set default +6 months
            // this.selExpiryDate = (todaysDate.getFullYear() + "-" + ("0" + (todaysDate.getMonth()+1)).slice(-2) + "-" + ("0" + todaysDate.getDate()).slice(-2));
            // setTimeout(() => {
            //   $('#link-expiry').val(this.selExpiryDate);  
            // });
            // this.implRef.isSetExpiry = true;
            // this.implRef.shareExpiry = todaysDate.getTime();
          } else {
            newDate.setHours(23, 59, 59, 0);
            this.defaultExpiryDate = (newDate.getDate() + " " + this.universalService.SHORT_MONTH_NAMES[newDate.getMonth()] + " " + newDate.getFullYear());
            this.implRef.isSetExpiry = true;
            this.implRef.shareExpiry = newDate.getTime();
          }
        } else {
          this.selExpiryDate = "";
        }
      } 
      //this.isValidInput = true;
      // if(this.isPasswordFieldEnabled == false) {
        this.isValidPasswordInput = true;
      // }
      this.universalService.isAnyChange = true;
    //})


    
  }

  buyStorageDetails() {
    this.listService.deSelectAll();
    this.closeNav();
    this.router.navigate(['/buystorage']);
  }

  async saveAccessDetails() {
    var self = this;
    //Expiry validation
    var expiryDate = $("#link-expiry").val();
    if(expiryDate != undefined && expiryDate != "") {
      expiryDate = expiryDate.toString();
      var todaysDate = new Date();
      todaysDate.setHours(0, 0, 0, 0);
      var newDate = new Date(expiryDate);

      if(expiryDate.length != 10 || newDate.toString() == "Invalid Date") {
        this.universalService.showToast(TOAST["INVALID_DATE"], "error");
        return;
      }
      if(newDate < todaysDate) {
        var msg = TOAST["LINK_EXPIRY_DATE"] + (todaysDate.getDate() + "/" + (todaysDate.getMonth() + 1) + "/" + todaysDate.getFullYear());
        this.universalService.showToast(msg, "error");
        // todaysDate = new Date(todaysDate.setMonth(todaysDate.getMonth()+6)); // to set default +6 months
        // this.selExpiryDate = (todaysDate.getFullYear() + "-" + ("0" + (todaysDate.getMonth()+1)).slice(-2) + "-" + ("0" + todaysDate.getDate()).slice(-2));
        // setTimeout(() => {
        //   $('#link-expiry').val(this.selExpiryDate);  
        // });
        // this.implRef.isSetExpiry = true;
        // this.implRef.shareExpiry = todaysDate.getTime();
        return;
      }
    }
    if(this.implRef.universalShareUrl != null && this.implRef.universalShareUrl != "") {
      this.cleverTapEventsService.publicShareLinkSaved();

      $(".btn-save").prop('disabled', true); // on click of save, restrict user to click again
      var apiResponse = await this.controller.updateUniversalShareLink();
      if(apiResponse["status"] == "success"){
        this.universalService.isAnyChange = false;
        this.isEditModeOn = false;
        if(this.universalService.isUserOnSharedLinkByMe) {
          if (!this.universalService.isMobileDevice) {
            // Save Password details
            if(this.implRef.sharePassword != "") {
              this.universalService.selectedNodes[0].isPassProtected = true;
              if(this.universalService.selectedFile.FullObject != null) {
                this.universalService.selectedNodes[0].FullObject.isPassProtected = true;
              }
              var res = this.listService.listOptions.api.applyTransaction({ update: this.universalService.selectedNodes });
              this.listService.listOptions.api.refreshCells();
            } else {
              this.universalService.selectedNodes[0].isPassProtected = false;
            if(this.universalService.selectedFile.FullObject != null) {
              this.universalService.selectedNodes[0].FullObject.isPassProtected = false;
            }
            var res = this.listService.listOptions.api.applyTransaction({ update: this.universalService.selectedNodes });
            this.listService.listOptions.api.refreshCells();
            }
            // Save Expiry details
            if(this.implRef.shareExpiry != "") {
              this.universalService.selectedNodes[0].isSetExpiry = true;
              this.universalService.selectedNodes[0].expiryDate = this.implRef.shareExpiry;
              if(this.universalService.selectedFile.FullObject != null) {
                this.universalService.selectedNodes[0].FullObject.isSetExpiry = true;
                this.universalService.selectedNodes[0].FullObject.expiryDate = this.implRef.shareExpiry;
              }
              var res = this.listService.listOptions.api.applyTransaction({ update: this.universalService.selectedNodes });
              this.listService.listOptions.api.refreshCells();
            } else {
              this.universalService.selectedNodes[0].isSetExpiry = false;
              if(this.universalService.selectedFile.FullObject != null) {
                this.universalService.selectedNodes[0].FullObject.isSetExpiry = false;
              }
              var res = this.listService.listOptions.api.applyTransaction({ update: this.universalService.selectedNodes });
              this.listService.listOptions.api.refreshCells();
            }
          } else {
            // Save password details
            if(this.implRef.sharePassword != "") {
              this.shareAccessService.sharedFilesList.map(function (object, index) {
                if (object.shareKey == self.universalService.selectedFile.objectKey) {
                  self.universalService.selectedFile.isPassProtected = true;
                }
              });
            } else {
              this.shareAccessService.sharedFilesList.map(function (object, index) {
                if (object.shareKey == self.universalService.selectedFile.objectKey) {
                  self.universalService.selectedFile.isPassProtected = false;
                }
              });
            }
            // Save expiry details
            if(this.implRef.shareExpiry != "") {
              this.shareAccessService.sharedFilesList.map(function (object, index) {
                if (object.shareKey == self.universalService.selectedFile.objectKey) {
                  self.universalService.selectedFile.isSetExpiry = true;
                  self.universalService.selectedFile.expiryDate = self.implRef.shareExpiry;
                }
              });
            } else {
              this.shareAccessService.sharedFilesList.map(function (object, index) {
                if (object.shareKey == self.universalService.selectedFile.objectKey) {
                  self.universalService.selectedFile.isSetExpiry = false;
                }
              });
            }
          }
        }
        // Data saved successfully. No message will be shown
      } else {
        if(apiResponse['data']['code'] && (apiResponse['data']['code'] == "SSOM0127" || apiResponse["error"]["code"] == 'SSOM0120')) {
          this.universalService.showToast(apiResponse["data"]['error'],"error");
        } else {
          this.universalService.showToast(TOAST["GENERIC_ERROR"], "error");
        }
      }
    } else {
      this.generateNewLink();
    }
  }

  copyShareText() {
    var self = this;
    self.universalService.showLoader = true;
    setTimeout(function() {
      if ( navigator.permissions == undefined) {
          const el = document.createElement("input");
          document.body.appendChild(el);
          el.value = self.implRef.universalShareUrl;
          el.select();
          document.execCommand("copy");
          document.body.removeChild(el);
          self.universalService.showToast(TOAST["COPY_LINK_SUCCESS"], "success");
      } else {
          navigator.clipboard.writeText(self.implRef.universalShareUrl).then(function() {
            /* clipboard successfully set */
            self.universalService.showLoader = false;
            self.copyText = "Copied";
            $('.btn-copy-link').css('pointer-events','none');
            setTimeout(() => {
              $('.btn-copy-link').css('pointer-events','');
              self.copyText = "Copy Link";
            }, 3000);
            self.universalService.isAnyChange = false;
            self.universalService.showToast(TOAST["COPY_LINK_SUCCESS"], "success");
          }, function(err) {
            /* clipboard write failed */
            console.log("error from clipboard writeTExt",err);
            self.universalService.showLoader = false;
            self.universalService.showToast(TOAST["COPY_LINK_FAILURE"], "success");
          });
      }
      self.isCopyLink = false;
    });
  }

  onLinkNameChange() {
    this.isEditModeOn = true;
    var linkName = $('#linkName').val();
    this.validateInput("name", linkName);
    this.universalService.isAnyChange = true;
    this.implRef.isShareNameUpdated = true;
  }

  onPasswordChange(){
    this.isEditModeOn = true;
    var linkPass = $('#linkPass').val();
    this.validateInput("password", linkPass);
    this.universalService.isAnyChange = true;
  }

  showPasswordContent(action) {
    var passElm = $("#linkPass");
    let passVal = passElm.val() as any;
    if(passVal.trim() == "") {
      return;
    }
    if(action == 'show') {
      if (passElm.attr("type") === "password") {
        passElm.attr("type", "text");
      }
      this.showPasswordData = true;
    } else {
      if (passElm.attr("type") === "text") {
        passElm.attr("type", "password");
      }
      this.showPasswordData = false;
    }
  }

  validateInput(field, input) {
    let value = input.trim();
    //var passExp = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/; //as per product, combination not mandate, use like name expression
    var passExp = /^([0-9]|[a-z])+([0-9a-z]+)$/i; // only alphanumeric
    //var nameExp = /^[A-Z0-9 _]*[A-Z0-9][A-Z0-9 _]*$/i; // to allow spaces use this regex
    var nameExp = /^[a-zA-Z0-9]+[a-zA-Z0-9-_ ]*[a-zA-Z0-9]$/; //Valid Characters include [A-z , a-z , 0-9, ‘_’ , ‘-’ & ‘⎵’]
    
    if(field == 'name') {
      if(!value.match(nameExp)) {
        $('.name-error').addClass('name-error-msg');
        this.isValidNameInput = false;
        this.implRef.shareName = "";
      } else {
        $('.name-error').removeClass('name-error-msg');
        this.isValidNameInput = true;
        this.implRef.shareName = value;
        if(this.isPasswordFieldEnabled == false) {
          this.isValidPasswordInput = true;
        }
      }
      
    } else if(field == 'password') {
      if(!value.match(passExp) || (value.length < 6 || value.length > 10)) {
        $('.password-error').addClass('pass-error-msg');
        this.isValidPasswordInput = false;
        this.implRef.sharePassword = "";
      } else {
        $('.password-error').removeClass('pass-error-msg');
        this.isValidPasswordInput = true;
        this.implRef.sharePassword = value;
      }
      if(this.isPasswordFieldEnabled == true) {
        this.implRef.isChangePassword = true;
      } else {
        this.implRef.isChangePassword = false;
      }
        
    }
  }

  copyShareLink() {
    this.isCopyLink = true;
    this.cleverTapEventsService.publicShareCopied();
    $("#linkName").prop('disabled', true); // Disable edit name once copy link is performed
    //If share link already generated
    if(this.implRef.universalShareUrl != null && this.implRef.universalShareUrl != "") {
      this.copyShareText();
    } else { //Share link not generated
      this.implRef.shareName = $('#linkName').val();
      if(this.implRef.shareName.trim() == "") {
        return;
      }
      this.generateNewLink();
    }
  }

  async generateNewLink() {
    if(this.implRef.shareName == "") {
      this.implRef.shareName = $('#linkName').val();
    }
    this.universalService.showLoader = true;
    /*if(ENV_CONSTANTS.constants["createOldShareLink"]){
      var oldShareLink = await this.controller.createShareLinkForSelectedObjects(this.universalService.selectedNodes);
      return
    }*/
    var apiResponse = await this.controller.getUniversalShareLinkForSelectedObjects(this.universalService.selectedNodes);
    if(apiResponse != null && apiResponse['shareURL'] != null && apiResponse['shareURL'] != "") {
      this.isEditModeOn = false;
      this.implRef.universalShareUrl = apiResponse['shareURL'];
      this.universalService.isAnyChange = false;
      if(this.isCopyLink == true) {
        this.universalService.showModalBackdrop();
        this.universalService.showLoader = true;
        this.copyShareText();
        setTimeout(() => {
          this.universalService.showLoader = false;
        }, 1000);
      } else {
        this.universalService.showLoader = false;
      }
    } else {
      this.universalService.showLoader = false;
      if((apiResponse['data'] && apiResponse['data']['code'] == "SSOM0127" || apiResponse["data"]["code"] == 'SSOM0120' )) {
        this.universalService.showToast(apiResponse["data"]['error'],"error");
      } 
      else if(apiResponse["error"] && apiResponse["error"]["code"] == 'SSOM0120'){
        this.universalService.showToast(apiResponse["error"]['error'],"error");
      }
      else if(apiResponse['data'] && apiResponse['data']["code"] == 'SSOM0141'){
        this.universalService.showToast(TOAST["PUBLIC_SHARING_DISABLED"],"error");
      }else {
        this.universalService.showToast(TOAST["GENERIC_ERROR"], "error");
      }
    }
  }

  shareUniversalLink(){
    this.cleverTapEventsService.publicShareOpenShareFrame();
    AppEvents.optionSelected.next({shareLink: true});
    $("#linkName").prop('disabled', true); // Disable edit name once copy link is performed
  }

  discardCalendarKeyInput() {
    //return false;
  }
}

